import { firestore } from "../firebase";
import UserInfo from "../models/UserInfo";

export default class DataRepositories {
    async getUserInfo(email) {
        const snap = await firestore.collection('Users').where('email', '==', email).get();
        return snap.docs.length > 0 && snap.docs[0].exists ? new UserInfo(snap.docs[0].data()) : null;
    }
}